import { Item } from "flows/Picking/models/item/types";

export enum DeliveryTag {
  HOME = "home",
  WORK = "work",
  OUTDOOR = "outdoor",
  OTHER = "other",
}

export interface Order {
  id: string;
  number: string | null;
  state: string | null;
  createdAt: string | null;
  isClickAndCollect: boolean;
  isNewCustomer: boolean;
  reseller:
    | "FLINK"
    | "UBER-EATS"
    | "UBER-EATS-CARREFOUR"
    | "WOLT"
    | "WOLT-BYOC"
    | "WOLT-BYOC-PLUS"
    | "JUST-EAT"
    | "JUST-EAT-REWE"
    | "JUST-EAT-WEINFREUNDE"
    | "JUST-EAT-REWEREADY"
    | "JUST-EAT-VIRTUAL"
    | "JUST-EAT-BEETS-ROOTS"
    | "JUST-EAT-BAKERY"
    | "JUST-EAT-BEN-JERRYS"
    | "JUST-EAT-IQOS"
    | "JUST-EAT-HEINEKEN"
    | null;
  externalDeliveryProvider: "UBER-DIRECT" | "WOLT-DRIVE" | "MOTIONTOOLS-FLEETLERY" | null;
  items?: Item[];
  handoverIdentifier: string | null;
  isInStore: boolean | null;
  ageVerification: "NONE" | "SIXTEEN" | "EIGHTEEN";
  weight: number;
  numberOfItems: number;
  deliveryTag: `${DeliveryTag}` | null;
}

export type OrderWithItems = Order & { items: Item[] };

export enum PickingState {
  PICKING_STATE_UNSPECIFIED = "PICKING_STATE_UNSPECIFIED",
  PICKING_STATE_READY_TO_PICK = "PICKING_STATE_READY_TO_PICK",
  PICKING_STATE_IN_PROGRESS = "PICKING_STATE_IN_PROGRESS",
  PICKING_STATE_COMPLETED = "PICKING_STATE_COMPLETED",
  PICKING_STATE_CANCELLED = "PICKING_STATE_CANCELLED",
}

export interface EmployeeInfo {
  id: string;
  displayName: string | null;
}

export interface OrderDetails extends Order {
  pickingState: PickingState | null;
  startedBy: EmployeeInfo | null;
  finishedBy: EmployeeInfo | null;
  handoverContainerIds: string[];
  handoverShelfNumbers: string[];
}
